// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.new-2 {
  margin: 0 auto;
  flex-grow: 1;
  display: flex;
}

.new-2__wrapper {
  width: 100%;
  margin: 0 auto;
  padding: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 10px;
}

.new-2__block {
  display: flex;
  gap: 25px;
}

.new-2__author {
  font-family: Oswald-Light, sans-serif;
  font-size: 17px;
  line-height: 1.35;
  font-weight: 300;
  margin: 15px 0;
}

.new-2__main {
  width: 90%;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  padding-bottom: 10px;
}

.new-2__text {
  font-family: Oswald-Light, sans-serif;
  font-size: 17px;
  line-height: 1.35;
  font-weight: 300;
  /* text-align: left; */
  margin: 0;
}

.new-2__main-partners {
  font-family: Oswald-Light, sans-serif;
  font-size: 17px;
  line-height: 1.35;
  font-weight: 300;
  margin: 0;
  text-align: left;
}

.new-2__main-partners-link {
  font-family: Oswald-Light, sans-serif;
  font-size: 17px;
  line-height: 1.35;
  font-weight: 300;
  text-decoration: underline;
  background-color: #e7e7e5;
  padding: 3px;
}

.new-2__btn {
  font-family: Oswald-Light, sans-serif;
  font-size: 16px;
  font-weight: 500;
  padding: 1px 15px;
  border: 1px solid #7e7b7b;
  background-size: cover;
  background-position: center;
}

.new-2__btn:hover {
  background-color: #ebf3f7;
}

@media screen and (max-width: 494px) {
  .new-2__main {
    width: 100%;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    padding-bottom: 15px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/New2/New2.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,WAAW;EACX,cAAc;EACd,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,WAAW;IACX,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,oBAAoB;EACtB;AACF","sourcesContent":[".new-2 {\r\n  margin: 0 auto;\r\n  flex-grow: 1;\r\n  display: flex;\r\n}\r\n\r\n.new-2__wrapper {\r\n  width: 100%;\r\n  margin: 0 auto;\r\n  padding: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: flex-start;\r\n  gap: 10px;\r\n}\r\n\r\n.new-2__block {\r\n  display: flex;\r\n  gap: 25px;\r\n}\r\n\r\n.new-2__author {\r\n  font-family: Oswald-Light, sans-serif;\r\n  font-size: 17px;\r\n  line-height: 1.35;\r\n  font-weight: 300;\r\n  margin: 15px 0;\r\n}\r\n\r\n.new-2__main {\r\n  width: 90%;\r\n  display: flex;\r\n  align-items: flex-end;\r\n  justify-content: space-between;\r\n  padding-bottom: 10px;\r\n}\r\n\r\n.new-2__text {\r\n  font-family: Oswald-Light, sans-serif;\r\n  font-size: 17px;\r\n  line-height: 1.35;\r\n  font-weight: 300;\r\n  /* text-align: left; */\r\n  margin: 0;\r\n}\r\n\r\n.new-2__main-partners {\r\n  font-family: Oswald-Light, sans-serif;\r\n  font-size: 17px;\r\n  line-height: 1.35;\r\n  font-weight: 300;\r\n  margin: 0;\r\n  text-align: left;\r\n}\r\n\r\n.new-2__main-partners-link {\r\n  font-family: Oswald-Light, sans-serif;\r\n  font-size: 17px;\r\n  line-height: 1.35;\r\n  font-weight: 300;\r\n  text-decoration: underline;\r\n  background-color: #e7e7e5;\r\n  padding: 3px;\r\n}\r\n\r\n.new-2__btn {\r\n  font-family: Oswald-Light, sans-serif;\r\n  font-size: 16px;\r\n  font-weight: 500;\r\n  padding: 1px 15px;\r\n  border: 1px solid #7e7b7b;\r\n  background-size: cover;\r\n  background-position: center;\r\n}\r\n\r\n.new-2__btn:hover {\r\n  background-color: #ebf3f7;\r\n}\r\n\r\n@media screen and (max-width: 494px) {\r\n  .new-2__main {\r\n    width: 100%;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    gap: 20px;\r\n    padding-bottom: 15px;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
